import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var mentionPluginKey = new PluginKey('mentionPlugin');